import { UseSubscriptionProductsStore } from '../store';
import { Products } from '../types';

export const subscriptionProductsTransformer = (
  defaultData: UseSubscriptionProductsStore[],
  newData: Products,
): UseSubscriptionProductsStore[] => {
  const payload: UseSubscriptionProductsStore[] = defaultData.map(
    (product, key) =>
      product.map((tier, item) => ({
        ...tier,
        product_id: newData[key].productid,
        tier_id: newData[key].tier_info[item]?.tierid,
        users: {
          max: newData[key].tier_info[item]?.max_licences.toString(),
          min: newData[key].tier_info[item]?.min_licences.toString(),
        },
      })),
  );
  return payload;
};
